export default {"src":"/_next/static/media/phone-message.53231407.svg","height":37,"width":37,"blurWidth":0,"blurHeight":0};